export default "__VITE_ASSET__vKwQOta8__"